import { apiFetch } from './api';

export interface TimelineActor {
  id: string;
  label: string;
}
export interface TimelineLink {
  label: string;
  href: string;
}

export interface TimelineSourceRef {
  label: string;
  icon?: string;
  at?: string;
  link?: string;
  detail?: string;
}

export interface TimelineItem {
  id: string;
  kind: 'event' | 'change' | 'payment' | 'automation_run' | 'relation' | 'funnel_transition';
  occurredAt: string;
  seq?: string | null;
  title: string;
  subtitle?: string | null;
  icon?: string;
  status?: string | null;
  actor?: TimelineActor | null;
  links?: TimelineLink[];
  source?: TimelineSourceRef | null;
  meta?: Record<string, unknown>;
}

/** Generalized per-entity activity log (Phase 2). entityType: CONTACT | PAYMENT | <slug>. */
export function fetchEntityTimeline(
  entityType: string,
  entityId: string,
  limit = 50,
): Promise<{ items: TimelineItem[] }> {
  return apiFetch(`/timeline/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}?limit=${limit}`);
}
